module.exports = "/images/GC-HeroM.jpg";